import { useState, useEffect } from 'react';
import { convertToFlatTree } from '../helpers/convert-to-flat-tree';
import prepareItems from '../helpers/prepare-items';
import buildItemsDepthMap from '../helpers/build-items-depth-map';
import { ROOT_ID } from '../constants';

const useTreeViewData = (items) => {
  const [flatTree, setFlatTree] = useState(() => convertToFlatTree(prepareItems(items), ROOT_ID));
  const [isDragging, setIsDragging] = useState(false);
  const [openNodeIds, setOpenNodeIds] = useState([]);
  const [itemsDepthMap, setItemsDepthMap] = useState(new Map());

  useEffect(() => {
    const prepared = prepareItems(items);
    const flat = convertToFlatTree(prepared, ROOT_ID);
    setFlatTree(flat);

    setItemsDepthMap(buildItemsDepthMap(items));
  }, [items]);

  useEffect(() => {
    const initialOpenIds = flatTree
      .filter(
        (node) =>
          node.droppable &&
          typeof node.data?.state?.isCollapsed === 'boolean' &&
          !node.data.state.isCollapsed
      )
      .map((node) => node.id);

    setOpenNodeIds(initialOpenIds);
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);
  return {
    flatTree,
    isDragging,
    openNodeIds,
    itemsDepthMap,
    setFlatTree,
    setIsDragging,
    setOpenNodeIds,
  };
};

export default useTreeViewData;
